<template>
  <div>
    <v-row no-gutters>
      <v-col class="py-0">
        <v-row no-gutters class="py-0">
          <v-col class="pl-3">
            <v-row no-gutters>
              <v-col class="py-0">
                <v-row no-gutters>
                  <v-expansion-panels
                    accordion
                    :value="expanded"
                    multiple
                  >
                    <v-expansion-panel>
                      <v-expansion-panel-header class="my-1" color="accent">
                        <p
                          depressed
                          class="font-weight-bold text-left text-uppercase text-customizer-exp"
                        >
                          {{ $t("page.events.registration.registered-spectator") }}
                        </p>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                          <v-card>
                            <v-row no-gutters>
                              <v-col class="text-left ma-3">
                                {{completed}} {{$t("page.events.tabulator.completed")}} <span class="pl-4">{{canceled}} {{$t("page.events.tabulator.canceled")}}</span> <br />
                                {{inPayment}} {{$t("page.events.tabulator.inPayment")}}
                              </v-col>
                            </v-row>
                              <RegisteredSpectatorList v-bind:list="list"/>
                          </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import RegisteredSpectatorList from "@/components/dashboard/registration/RegisteredSpectatorList.vue";
import { apiCalls } from "@/mixins/apiCalls.js";

export default {
    mixins: [apiCalls],
    components: {
        RegisteredSpectatorList
    },
    data() {
        return {
            expanded: [0],
            list: [],
            completed: 0,
            canceled: 0,
            inPayment: 0
        }
    },
    methods: {
        async loadList() {
            let list = [];
            const response = await this.api(
                "get",
                `/api/v1/promoter/registeredSpectators/getByEvent/${this.$route.params.id}`
            );
            if(response.success) {
                list = response.message.data.map(el => {
                    return {
                        id: el.id,
                        firstName: el.name,
                        lastName: el.lastName,
                        phone: el.phone,
                        dateBirth: el.dateBirth,
                        registeredBy: el.fullNameRB,
                        status: this.$t("page.events.tabulator."+el.status),
                        created_at: el.created_at
                    }
                });
                this.completed = response.message.completed;
                this.canceled = response.message.canceled;
                this.inPayment = response.message.inPayment;
            }
            this.list = list;
        }
    },
    created() {
        this.loadList();
    }
};
</script>